import { render, staticRenderFns } from "./Footnote.vue?vue&type=template&id=5728af48&"
import script from "./Footnote.vue?vue&type=script&lang=js&"
export * from "./Footnote.vue?vue&type=script&lang=js&"
import style0 from "./Footnote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
